import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../../app.component';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import { OrderPipe } from 'ngx-order-pipe';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss']
})
/** News component*/
export class NewsComponent {
    /** News ctor */
  news: any;
  route: any;
  imgUrl: any;
  fileUrl: any;
  title: any;
  itemsPerPage: number;
  Search: any;
  paginationPageNumber: number;
  newsCount: any;
  modeltitle: any;
  content: any;
  image: any;
  currentDate: any = new Date();
  MenuList: any;
  newsSpinner: boolean;
  multipleEntry: boolean = false;
  constructor(private spinner: NgxSpinnerService,private appComponent: AppComponent, private http: HttpClient, private router: Router, private datePipe: DatePipe, private orderpipe: OrderPipe) {
    this.imgUrl = window["orginalImgUrl"];
    this.fileUrl = window["getfile"];
    var str = this.router.url;
    this.route = str.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
  }
  ngOnInit() {
    this.spinner.show();
    this.paginationPageNumber = 1;
    this.itemsPerPage = 5;
    this.getMenuName();
    this.getNews();
    
  }

  search() {
    this.paginationPageNumber = 1;
  }

  getMenuName() {
    this.http.get(this.appComponent.APIUrl + 'MenuMaster/', {
    }).subscribe((data: any) => {
      this.MenuList = data.menuMasterDTO.filter(x => x.link == this.route);
      this.title = this.MenuList[0].title;
      this.multipleEntry = this.MenuList[0].multipleEntry;
    });
  }
  getNews() {
    this.newsSpinner = true;
    this.http.get(this.appComponent.APIUrl + 'Post/GetPostByRoute/' + this.route, {
    }).subscribe((data: any) => {
      this.news = data.postDTO.filter(x => x.status == 'Active' && x.displayonhome == 1);
      this.newsCount = this.news.length;
      this.currentDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd' + 'T00:00:00');
      this.newsSpinner = false;
    });
  }

  itemPerPagePagination(event: any) {
    this.itemsPerPage = event.target.value;
  }
}
